import React, { useCallback, useState } from "react";
import SiigoErrorModal from "./SiigoErrorModal";

/**
 * Encapsula el estado del modal de error de Siigo para reutilizarlo en cualquier
 * componente. Devuelve `showError(rawError)` para abrirlo y `errorModal` (el JSX
 * ya renderizable) para colocar en el árbol.
 */
export default function useSiigoErrorModal() {
  const [rawError, setRawError] = useState(null);

  const showError = useCallback((error) => {
    const text = typeof error === "string" ? error : error == null ? "" : JSON.stringify(error);
    setRawError(text || "Error desconocido.");
  }, []);

  const hideError = useCallback(() => setRawError(null), []);

  const errorModal = (
    <SiigoErrorModal open={rawError !== null} rawError={rawError} onClose={hideError} />
  );

  return { showError, errorModal };
}
